import React from 'react';
import PropTypes from 'prop-types';
import {AzoButton} from "../../../index";
import {Typography} from "@material-ui/core";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import useStyles from "./StopoverOpenButtonStyles";

const StopoverOpenButton = ({title, subtitle, onClick, endIcon, disabled, hideSubtitle}) => {

    const classes = useStyles();

    return (
        <AzoButton
            className={classes.button}
            onClick={onClick}
            disabled={disabled}
            variant={'contained'}
            color={'secondary'}
            size={'medium'}
            disableElevation
            fullWidth
            classes={{
                label: classes.buttonLabel
            }}>
            <Typography className={classes.title} variant={'subtitle1'}>
                {title}
            </Typography>
            <Typography variant={'subtitle1'} className={classes.subtitle}>
                {!hideSubtitle && subtitle} {endIcon}
            </Typography>
        </AzoButton>
    );
};

StopoverOpenButton.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    onClick: PropTypes.func,
    endIcon: PropTypes.node,
    disabled: PropTypes.bool,
    hideSubtitle: PropTypes.bool,
};

StopoverOpenButton.defaultProps = {
    title: 'Add Stopover',
    subtitle: 'Click to add',
    onClick: null,
    endIcon: <ArrowDropDownIcon/>,
    disabled: false,
    hideSubtitle: false,
};

export default StopoverOpenButton;